module.exports = __webpack_public_path__ + "static/media/antigua-beaches-42.33f88ca9.jpg";